function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.5889 88.242L81.0857 80.7435M77.0089 173.974V156.478C77.0259 148.728 74.4459 141.196 69.6805 135.082C63.0694 126.557 59.4879 116.074 59.5013 105.288C59.5013 92.3618 64.6397 79.9647 73.786 70.8242C82.9324 61.6837 95.3375 56.5486 108.272 56.5486C120.184 56.5472 131.683 60.9044 140.6 68.7974C149.516 76.6903 155.232 87.5728 156.668 99.3897C157.036 102.127 157.776 104.801 158.869 107.338L169.224 132.183C169.543 132.948 169.666 133.78 169.583 134.605C169.5 135.429 169.213 136.22 168.749 136.907C168.285 137.592 167.659 138.152 166.925 138.536C166.192 138.92 165.375 139.116 164.547 139.106H157.044V159.102C157.044 160.428 156.517 161.7 155.578 162.637C154.64 163.575 153.368 164.101 152.041 164.101H137.035C136.375 164.101 135.721 164.231 135.112 164.484C134.502 164.737 133.949 165.108 133.483 165.576C133.02 166.043 132.653 166.597 132.404 167.206C132.155 167.815 132.029 168.467 132.033 169.125V174.124L77.0089 173.974ZM109.523 89.1418C103.424 89.1938 97.4934 91.1489 92.5607 94.7341C87.628 98.3192 83.9397 103.355 82.011 109.138C83.9461 114.916 87.6361 119.948 92.5674 123.532C97.4987 127.116 103.426 129.074 109.523 129.133C115.622 129.082 121.552 127.126 126.485 123.541C131.418 119.956 135.106 114.92 137.035 109.138C135.113 103.351 131.426 98.3109 126.492 94.7248C121.558 91.1386 115.624 89.1863 109.523 89.1418ZM109.523 149.129V136.632V149.129ZM109.523 81.6434V69.146V81.6434ZM119.527 109.138C119.527 106.486 118.473 103.943 116.597 102.068C114.721 100.193 112.176 99.1397 109.523 99.1397C106.87 99.1397 104.325 100.193 102.449 102.068C100.573 103.943 99.5187 106.486 99.5187 109.138C99.5187 111.789 100.573 114.332 102.449 116.207C104.325 118.082 106.87 119.136 109.523 119.136C112.176 119.136 114.721 118.082 116.597 116.207C118.473 114.332 119.527 111.789 119.527 109.138ZM124.83 146.08L120.228 134.982L124.83 146.08ZM98.8183 83.293L94.2164 72.1953L98.8183 83.293ZM98.8433 134.832L94.2414 145.93L98.8433 134.832ZM124.855 72.0454L120.253 83.1431L124.855 72.0454ZM88.6888 129.833L81.1855 137.332L88.6888 129.833ZM137.76 80.7936L130.257 88.292L137.76 80.7936ZM137.76 137.382L130.257 129.883L137.76 137.382Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2 44.5859C33.6875 32.3121 45.5905 22.1134 59.1738 14.6198C72.7571 7.12624 87.7325 2.49678 103.175 1.01734C118.618 -0.462101 134.199 1.23989 148.958 6.01821C163.717 10.7965 177.34 18.5497 188.985 28.799C200.631 39.0483 210.051 51.5761 216.665 65.6087C223.28 79.6413 226.947 94.8808 227.441 110.386C227.934 125.892 225.244 141.334 219.537 155.759C213.829 170.184 205.224 183.286 194.255 194.255",
  stroke: "url(#paint1_linear)",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M145.061 223.165C125.177 228.823 104.125 228.942 84.1778 223.51C64.2307 218.078 46.1461 207.3 31.8762 192.342C17.6063 177.383 7.69312 158.811 3.20673 138.63C-1.27966 118.449 -0.168843 97.4257 6.41928 77.8299",
  stroke: "url(#paint2_linear)",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 45.5968,
  y1: 88.5987,
  x2: 185.472,
  y2: 115.577,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 256.79,
  y1: 165.848,
  x2: -31.3981,
  y2: 106.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -28.7899,
  y1: 62.1504,
  x2: 259.398,
  y2: 121.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 120,
  fill: "white",
  transform: "translate(57 54)"
})));

function SvgTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.94c8b970.svg";
export { ForwardRef as ReactComponent };